import { apiService } from "./api";

export interface OrderChannel {
    order_channel_id: string;
    name: string;
    type: "OFFLINE" | "ONLINE";
    is_active: boolean;
    created_at: string;
}

export interface OrderChannelSimple {
    order_channel_id: string;
    name: string;
    type: "OFFLINE" | "ONLINE";
}

export const orderChannelService = {
    async getOrderChannels(activeOnly: boolean = true): Promise<OrderChannel[]> {
        return apiService.get<OrderChannel[]>(
            `/order-channels/?active_only=${activeOnly}`,
        );
    },

    async getOrderChannelsSimple(
        activeOnly: boolean = true,
    ): Promise<OrderChannelSimple[]> {
        return apiService.get<OrderChannelSimple[]>(
            `/order-channels/simple?active_only=${activeOnly}`,
        );
    },

    async getOrderChannel(id: string): Promise<OrderChannel> {
        return apiService.get<OrderChannel>(`/order-channels/${id}`);
    },

    async createOrderChannel(
        data: Omit<OrderChannel, "order_channel_id" | "created_at">,
    ): Promise<OrderChannel> {
        return apiService.post<OrderChannel>("/order-channels/", data);
    },

    async updateOrderChannel(
        id: string,
        data: Partial<OrderChannel>,
    ): Promise<OrderChannel> {
        return apiService.put<OrderChannel>(`/order-channels/${id}`, data);
    },

    async deleteOrderChannel(id: string): Promise<void> {
        return apiService.delete<void>(`/order-channels/${id}`);
    },
};
